import { EditorExtensionEnum as e } from "./enums/editor-extensions-enum.mjs";
import { Hint as t } from "./components/hint.mjs";
import { FontFamilyEnum as n, getEmailFontFamilyOptionsData as r } from "./extensions/font-family-extension/utils.mjs";
import { useTranslation as i } from "./i18n.mjs";
import { TipTapEditor as a } from "./tip-tap.mjs";
import { getUrlSchemeOptions as o } from "./extensions/link-extension/url-scheme-options.mjs";
import { FileSourceEnum as s } from "@systemeio/file-manager";
import { jsx as c } from "react/jsx-runtime";
//#region src/tip-tap-email-editor.tsx
var l = (l) => {
	let { t: u } = i(), d = o(u);
	return /* @__PURE__ */ c(a, {
		defaultFont: n.Arial,
		...l,
		extensionOptions: {
			...l.extensionOptions,
			[e.Image]: {
				...l.extensionOptions?.[e.Image],
				schemeOptions: d,
				fileSource: s.Email
			},
			[e.Link]: {
				...l.extensionOptions?.[e.Link],
				schemeOptions: d,
				fileSource: s.Email
			},
			[e.TextColor]: {
				...l.extensionOptions?.[e.TextColor],
				showAlpha: !1
			},
			[e.TextBackgroundColor]: {
				...l.extensionOptions?.[e.TextBackgroundColor],
				showAlpha: !1
			},
			[e.FontFamily]: {
				...l.extensionOptions?.[e.FontFamily],
				fontFamilyOptionsData: r(u),
				noFontFamilyElement: /* @__PURE__ */ c(t, {
					inline: !0,
					passive: !0,
					label: u("font_family.mailbox_default_hint"),
					children: u("font_family.mailbox_default")
				})
			}
		}
	});
};
//#endregion
export { l as TipTapEmailEditor };
